export function createChartingSidebarPanelItems({ capabilities }) {
    return [
        {
            key: 'description',
            icon: 'pi pi-building',
            label: 'Empresa',
            title: 'Empresa',
            disabled: !capabilities.canUseDescriptionPanel,
            reason: 'Tu plan actual no tiene acceso a empresa.'
        },
        {
            key: 'analysis',
            icon: 'pi pi-chart-bar',
            label: 'Análisis',
            title: 'Análisis',
            disabled: !capabilities.canViewBasicInsights && !capabilities.canUseFundamental,
            reason: 'Tu plan actual no tiene acceso al análisis.'
        },
        {
            key: 'alarms',
            icon: 'pi pi-bell',
            label: 'Alarmas',
            title: 'Alarmas',
            disabled: !capabilities.canUseAlerts,
            reason: 'Tu plan actual no tiene acceso a alarmas.'
        },
        {
            key: 'error',
            icon: 'pi pi-exclamation-triangle',
            label: 'Reportar',
            title: 'Reportar error',
            disabled: !capabilities.canReportErrors,
            reason: 'Necesitas iniciar sesión para reportar incidencias.'
        }
    ];
}
